import './assets/workspace.css'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import http from './services/http'

Vue.config.productionTip = false
Vue.prototype.$http = http
// Relative API endpoint, as in main-template.js. nginx routes it to the backend.
http.defaults.baseURL = '/api'

new Vue({ router, store, render: h => h(App) }).$mount('#app')

